export default (object, keys) => keys && keys.length && keys.reduce((curr, key) => curr ? curr[key] : '———', object);
